module.exports = __webpack_public_path__ + "static/media/mobile.bf081993.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/mobile.png
// module id = 288
// module chunks = 0